import { DateRange, PopoverDatePicker } from '@round/creatorbase-ui';
import { DATE_PRESETS } from './helpers';
import moment from 'moment';

type Props = {
    dateRange?: DateRange;
    onDateRangeChange: (dateRange?: DateRange) => void;
};

const DateRangePicker = ({ dateRange, onDateRangeChange }: Props) => {
    return (
        <PopoverDatePicker
            align="end"
            mode="range"
            selected={dateRange}
            onSelect={onDateRangeChange}
            presets={DATE_PRESETS}
            selectedPreset={DATE_PRESETS.find((preset) => {
                return moment(dateRange?.to).diff(dateRange?.from, 'days') === preset.value;
            })}
            onPresetSelected={(preset) => {
                onDateRangeChange({
                    from: moment().subtract(preset.value, 'days').toDate(),
                    to: new Date(),
                });
            }}
            numberOfMonths={2}
            defaultMonth={dateRange?.to}
            disabled={{ after: new Date() }}
        />
    );
};

export default DateRangePicker;
